<!-- svg.component.html -->
<svg xmlns="http://www.w3.org/2000/svg" [attr.viewBox]="viewBox" [attr.width]="width" [attr.height]="height" [attr.fill]="fill" [class]="class" [innerHTML]="svgContent"></svg>
